
import {
  API_Client,
  APIs_setupAccounts,
  APIs_setupSavingRules,
  APIs_GetSweepInputs,
  APIs_Scenario,
  API_tokenRefresh,
} from "./api.jsx";

export const empty_uuid = "00000000-0000-0000-0000-000000000000";

const defAccountType = {
  Employment: "Employment",
  Expenses: "Expenses",
  NonRegistered: "NonRegistered",
  Registered: "TFSA",
  Retirement: "RRSP",
  Inheritance: "Inheritance",
  Property: "Property",
  Liability: "Liabilities",
  DBPension: "",
  InvestLoan: "InvestLoan",
  Annuity: "",

};

export const getOptions = {
  method: "GET",
  credentials: "include",
  headers: {
    Accept: "application/json; charset=UTF-8",
  },
};

export const putOptions = {
  method: "PUT",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

export const postOptions = {
  method: "POST",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

export const deleteOptions = {
  method: "DELETE",
  credentials: "include",
};

export const scenOptionClient = (clientJson) => {
  return scenOption(clientJson.Scenario.uuid)

};

export const scenOption = (scen_uuid) => {
  let scen = "";
  if (scen_uuid !== empty_uuid) {
    scen = "?scen_uuid=" + scen_uuid;
  }
  return scen;
};

export const clientScenOption = (clientJson) => {
  let scen = "";
  if (clientJson.Scenario.uuid !== empty_uuid) {
    scen = "?client_uuid=" + clientJson.uuid + "&scen_uuid=" + clientJson.Scenario.uuid;
  }
  return scen;
};

const accName = (name, nameOrig, add, account_uuid) => {
  let acc = "";
  if (account_uuid && account_uuid !== empty_uuid) {
    acc = "_uuid/" + account_uuid
  } else {
    if (add) {
      acc = "/new"
    } else {
      if (nameOrig !== "") {
        acc = "/new"
      }
    }
  }
  return acc;
};

export const AccountUrl_get = (
  clientJson,
  api_client_type,
  account,
  account_uuid,
  add,
  accountType,
  extraArg = "",
) => {
  let base = "";
  let acc = "";
  if (add) {
    base = "base";
    let def = defAccountType[accountType];
    if (def !== "") {
      acc = "/" + def;
    }
  } else {
    if (account_uuid && account_uuid !== empty_uuid) {
      acc = "_uuid/" + account_uuid
    } else {
      if (account !== "") {
        acc = "/" + encodeURIComponent(account);
      }
    }
  }
  let url =
    API_Client +
    clientJson.uuid +
    "/" +
    api_client_type +
    base +
    acc
  let q = scenOptionClient(clientJson)
  q = AddQueryString(q, extraArg)

  return UrlOptions(clientJson, url, q)
};

export const AccountUrl_put = (
  clientJson,
  api_client_type,
  account,
  account_uuid,
  nameOrig,
  add,
  extraArg = "",
) => {
  console.log(account);
  console.log(nameOrig);
  console.log(add);
  let acc = accName(account, nameOrig, add, account_uuid);

  let url =
    API_Client +
    clientJson.uuid +
    "/" +
    api_client_type +
    acc
  let q = scenOptionClient(clientJson)
  q = AddQueryString(q, extraArg)
  return UrlOptions(clientJson, url, q)
};

export const AddIncomeUrl_get = (clientJson, api_client_type, year, add, extraArg = "") => {
  let base = "";
  let slashyear = "/" + year;

  if (add) {
    base = "base";
    slashyear = "";
  }
  let url =
    API_Client +
    clientJson.uuid +
    "/" +
    api_client_type +
    base +
    slashyear
  let q = scenOptionClient(clientJson)
  q = AddQueryString(q, extraArg)
  return UrlOptions(clientJson, url, q)

};

export const AddIncomeUrl_put = (clientJson, api_client_type, year, extraArg = "") => {
  let url =
    API_Client +
    clientJson.uuid +
    "/" +
    api_client_type +
    "/" +
    year
  let q = scenOptionClient(clientJson)
  q = AddQueryString(q, extraArg)
  return UrlOptions(clientJson, url, q)
};

export const SavingRuleUrl_get = (
  clientJson,
  api_client_type,
  when,
  year,
  add,
  extraArg = "",
) => {
  let base = "";
  let slashyear = "/" + year;

  if (add) {
    base = "base";
    slashyear = "";
  }
  let url =
    API_Client +
    clientJson.uuid +
    "/" +
    api_client_type +
    base +
    "/" +
    when +
    slashyear
  let q = scenOptionClient(clientJson)
  q = AddQueryString(q, extraArg)
  return UrlOptions(clientJson, url, q)
};

export const SavingRuleUrl_put = (clientJson, api_client_type, when, year, extraArg = "") => {
  let url =
    API_Client +
    clientJson.uuid +
    "/" +
    api_client_type +
    "/" +
    when +
    "/" +
    year
  let q = scenOptionClient(clientJson)
  q = AddQueryString(q, extraArg)
  return UrlOptions(clientJson, url, q)

};

export const ScenOptionUrl_spec = (clientJson, verb, scen_uuid = null, extraArg = "") => {
  let uuid = scen_uuid
  if (uuid === null) {
    uuid = clientJson.Scenario.uuid
  }
  let url =
    API_Client +
    clientJson.uuid +
    verb
  let q = scenOption(uuid)
  q = AddQueryString(q, extraArg)
  return UrlOptions(clientJson, url, q)
};


export const SetupAccountsUrl_get = (clientJson, scen_uuid, extraArg = "") => {
  return ScenOptionUrl_spec(clientJson, APIs_setupAccounts, scen_uuid, extraArg)
};

export const SetupSavingRulesUrl_get = (clientJson, scen_uuid, extraArg = "") => {
  return ScenOptionUrl_spec(clientJson, APIs_setupSavingRules, scen_uuid, extraArg)
};

export const SweepInputUrl_get = (clientJson) => {
  return ScenOptionUrl_spec(clientJson, APIs_GetSweepInputs, null, "")
};

export const ScenarioUrl_spec = (clientJson, scen_uuid, ext = "", q = "") => {
  let url = API_Client + clientJson.uuid + APIs_Scenario + "/" + scen_uuid;
  if (ext !== "") {
    url += "/" + ext;
  }
  return UrlOptions(clientJson, url, q);
};
export const AddQueryString = (q, s) => {
  if (s !== "") {
    if (q === "") {
      q = "?" + s;
    } else {
      q += "&" + s;
    }
  }
  return q;
};

export const ScenarioUrl = (clientJson, ext = "", q = "") => {
  return ScenarioUrl_spec(clientJson, clientJson.Scenario.uuid, ext, q);
};

export const SweepUrl = (clientJson, ext = "", q = "") => {
  return ScenarioUrl_spec(clientJson, clientJson.Sweep.uuid, ext, q);
};

export const ScenarioUrl_post = (clientJson) => {
  return API_Client + clientJson.uuid + APIs_Scenario;
};

export const UrlOptions = (clientJson, url, q = "") => {
  if (clientJson.public) {
    q = AddQueryString(q, "public=true");
  } else if (clientJson.shared) {
    q = AddQueryString(q, "shared=true");
  }
  return url + q;
};

export const ftchPlus = async (url, options = {}, refresh = true) =>
  fetch(url, options)
    .then(async res => {
      // console.log(res.ok)
      if (res.ok) {
        return res.json()
      } else if (res.status === 401) {
        if (refresh) {
          console.log("401 do refresh")
          const res_refresh = await fetch(API_tokenRefresh, postOptions)
          console.log("did refresh")
          if (res_refresh.ok) {
            const x = await res_refresh.text()
            const json = await ftchPlus(url, options, false)
            return json
          } else {
            console.log("refresh failed")
            throw new Error("MyOwnFP: Token refresh failed. Please login again")
          }
        }
        else {
          console.log("got 401 again after refresh... shouldn't happen")
          throw new Error("MyOwnFP: Fetch failed after token refresh. Please login again")
        }
      } else {
        console.log(res)
      }
      console.log(res)
      let j = await res.json()
      console.log(j)
      let errmsg = "MyOwnFP:" + j.message
      if (typeof errmsg !== "string") {
        errmsg = "MyOwnFP: hmm, bad error message returned"
      }
      throw new Error(errmsg)
    })
    .catch(async error => {
      console.log(error)
      if (error.message.includes("MyOwnFP:")) {
        throw error
      }
      throw new Error("Failed to connect to MyOwnFP services")

    })

export const FtchPlusError = (err) => {
  // const { logout_ } = useAuth();
  // console.log(err)
  // if (err.message === "logout") {
  //   logout_()
  // }

}

export const CleanAvail = (form) => {
  let post = structuredClone(form);
  let c = post.Clients[0]
  if (post.DataSet[c] !== undefined && post.DataSet[c].Avail) {
    delete post.DataSet[c].Avail;
    if (post.DataSet[c].Name === "") {
      delete post.DataSet[c];
    }
  }
  if (post.Clients.length > 1) {
    let c = post.Clients[1]
    if (post.DataSet[c] !== undefined && post.DataSet[c].Avail) {
      delete post.DataSet[c].Avail;
      if (post.DataSet[c].Name === "") {
        delete post.DataSet[c];
      }
    }
  }
  return post
}

